import React from "react";

export default function CategoryGrid({ categories, onSelectCategory }) {
  return (
    <div className="section" id="kategorien">
      <div className="heading">Speisekarte</div>
      <div className="heading-line"></div>
      <div className="category-grid">
        {categories.map((cat) => (
          <div
            key={cat.id}
            className="category"
            onClick={() => onSelectCategory(cat)}
          >
            <img src={cat.image} alt={cat.title} />
            <span>{cat.title}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
